module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title_heartbook":"I like you!"},"de":{"title_heartbook":"Ich hab dich lieb!","title_birthdaybook":"Alles Gute zum Geburtstag!","title_starbook":"Gute Nacht!","title_treasurebook":"Mein Schatz"}}')
  delete Component.options._Ctor
}
